/**
 * Leitura das categorias e grupos para as alternativas do estudo
 * (alternativas.ts faz a conta). Só grupos do segmento com vaga, mais o grupo
 * da proposta mesmo sem vaga, para ele aparecer como "este plano".
 */
import { supabase } from '../providers/supabase/supabase';
import { todasAsLinhas } from '../providers/supabase/todasAsLinhas';
import type { Segmento } from './comparativo';
import {
  COLUNAS_CATEGORIA,
  COLUNAS_GRUPO,
  candidatosDasLinhas,
  codigoDoSegmento,
  faixaDeCredito,
  type Candidato,
  type DetalhesGrupo,
} from './alternativas';

export { vagasDe } from './alternativas';

export const buscarCandidatos = async (
  segmento: Segmento,
  creditoPorCota: number,
  grupoAtual: number | null,
): Promise<Candidato[]> => {
  const faixa = faixaDeCredito(creditoPorCota);
  const [cats, grupos] = await Promise.all([
    todasAsLinhas<Record<string, unknown>>(() =>
      supabase
        .from('servopa_group_categories')
        .select(COLUNAS_CATEGORIA)
        .gte('valor_credito', faixa.min)
        .lte('valor_credito', faixa.max),
    ),
    supabase.from('servopa_groups_enriched').select(COLUNAS_GRUPO).eq('segment', codigoDoSegmento(segmento)),
  ]);
  if (cats.error) throw new Error(cats.error.message ?? 'Categorias indisponíveis');
  if (grupos.error) throw new Error(grupos.error.message);
  return candidatosDasLinhas(cats.data ?? [], (grupos.data ?? []) as Record<string, unknown>[], grupoAtual);
};

export const carregarDetalhesGrupo = async (grupo: number): Promise<DetalhesGrupo> => {
  const { data, error } = await supabase
    .from('servopa_group_details')
    .select('lance_embutido, tipo_seguro, taxa_seguro')
    .eq('group_number', grupo)
    .maybeSingle();
  if (error) throw new Error(error.message);
  const fixo = Number(data?.lance_embutido);
  const taxa = Number(data?.taxa_seguro);
  return {
    lanceFixoPct: Number.isFinite(fixo) && fixo > 0 ? fixo : 30,
    tipoSeguro: data?.tipo_seguro ?? null,
    taxaSeguro: Number.isFinite(taxa) ? taxa : null,
  };
};
